'use client';

import { useConfig } from '@/app/contexts/ConfigContext';
import { SERVICE_TYPES } from '@/helpers/enums';
import { ServiceType } from '@/types';
import CustomLink from './CustomLink';

export default function NavMultiAstrologyMeditationLove() {
  const { config, setConfig, wording, updateWording, selectedLanguage } =
    useConfig();

  const handleConfig = (type: ServiceType) => {
    setConfig({
      ...config,
      serviceType: type,
    });
    updateWording(type, selectedLanguage);
  };

  const styleLink =
    'text-neutral-800 p-5 text-xl flex justify-center font-bold';

  return (
    <div className='hidden 2xl:flex items-center gap-2 sm:gap-4 2xl:gap-8'>
      <CustomLink
        href='/media/media_all'
        onClick={() => {
          handleConfig(SERVICE_TYPES.ASTROLOGY);
        }}
      >
        <div
          className={styleLink}
          style={{ color: config.theme.textColorDark }}
        >
          {wording?.components_header_media_content}
        </div>
      </CustomLink>
      <CustomLink
        href='/media/media_all'
        onClick={() => {
          handleConfig(SERVICE_TYPES.MEDITATION);
        }}
      >
        <div
          className={styleLink}
          style={{ color: config.theme.textColorDark }}
        >
          {wording?.components_header_media_multi_content_2}
        </div>
      </CustomLink>
      <CustomLink
        href='/media/media_all'
        onClick={() => {
          handleConfig(SERVICE_TYPES.LOVE);
        }}
      >
        <div
          className={styleLink}
          style={{ color: config.theme.textColorDark }}
        >
          {wording?.components_header_media_multi_content_3}
        </div>
      </CustomLink>
      <CustomLink href='/text1'>
        <div
          className={styleLink}
          style={{ color: config.theme.textColorDark }}
          onClick={() => {
            handleConfig(SERVICE_TYPES.MEDITATION);
          }}
        >
          {wording?.components_header_text1}
        </div>
      </CustomLink>
      <CustomLink href='/text2'>
        <div
          className={styleLink}
          style={{ color: config.theme.textColorDark }}
          onClick={() => {
            handleConfig(SERVICE_TYPES.ASTROLOGY);
          }}
        >
          {wording?.components_header_text2}
        </div>
      </CustomLink>
    </div>
  );
}
